import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import { generateEntityWithChildIds } from 'src/shared/entities/utils/generate-base-entity'

export const createPriceElement = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): PriceElementInterface => {
  const entity: PriceElementInterface = {
    ...generateEntityWithChildIds(EntityTypeEnum.PriceElement, parentId, masterBlockId),

    popupIdFirstPlan: null,
    popupIdSecondPlan: null,
    popupIdThirdPlan: null,
    popupIdFourthPlan: null,

    fontFamily: 'Caveat',
    fontStyle: 'normal',
    fontWeight: '700',
  }

  return entity
}
